module.exports = __webpack_public_path__ + "static/media/arrow-chevron-left.c2ce5177.svg";